'use client';

import { useLayoutEffect, useEffect, useState } from 'react';
import { useLocalStorage } from 'usehooks-ts';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Button } from '@/components/ui/button/button.component';
import { Link } from '@/components/ui/link/link.component';
import { gtag } from '@/utils/gtag';

export default function CookiesFooter() {
  const [{ accepted }, setCookieConsent] = useLocalStorage<{ accepted: boolean }>('cookie-consent', { accepted: false });
  const [isMounted, setIsMounted] = useState<boolean>(false);

  useLayoutEffect(() => setIsMounted(true), []);

  const acceptCookies = () => {
    setCookieConsent({ accepted: true });
  };

  useEffect(() => {
    const consent = accepted ? 'granted' : 'denied';

    gtag('consent', 'update', {
      ad_storage: consent,
      ad_user_data: consent,
      ad_personalization: consent,
      analytics_storage: consent,
    });

    gtag('event', 'consent.update');
  }, [accepted]);

  if (!isMounted || accepted) {
    return null;
  }

  return (
    <div className="fixed bottom-0 bg-white shadow-modal w-full p-5 md:p-6 lg:p-8 z-[60] pointer-events-auto">
      <div
        className="flex flex-col md:flex-row justify-between gap-6 md:mx-auto md:max-w-3xl lg:max-w-4xl xl:max-w-5xl 3xl:max-w-7xl"
      >
        <p data-testid={DataTestIdEnum.COOKIES_FOOTER_TEXT} className="text-gray-800 font-light">
          Para melhorar sua experiência, utilizamos cookies. Ao aceitar, você concorda com nossa
          {' '}
          <Link href="/politica-de-privacidade/" className="text-green-500 font-semibold hover:underline">
            Política de Privacidade
          </Link>
          {' '}
          e terá acesso total ao site.
        </p>

        <Button
          data-testid={DataTestIdEnum.COOKIES_FOOTER_BUTTON}
          className="w-full md:w-[12.5rem] h-[3rem]"
          onClick={acceptCookies}
        >
          Aceitar cookies
        </Button>
      </div>
    </div>
  );
}
